import { isObject } from './utils'

export function computeNetworkOptions(userOptions) {
  if (!userOptions || !isObject(userOptions)) return networkOptions;
  return combineNetworkOptionsRecursive(networkOptions, userOptions);
}

function combineNetworkOptionsRecursive(libOptions, userOptions) {
  const ret = {};
  for (let libOption in libOptions) {
    if (libOption in userOptions) {
      if (isObject(libOptions[libOption]) && isObject(userOptions[libOption])) {
        ret[libOption] = combineNetworkOptionsRecursive(libOptions[libOption], userOptions[libOption])
      } else {
        ret[libOption] = userOptions[libOption];
      }
    } else {
      ret[libOption] = libOptions[libOption];
    }
  }
  for (let userOption in userOptions) {
    if (!(userOption in libOptions)) {
      ret[userOption] = userOptions[userOption];
    }
  }  
  return ret;
}

// https://visjs.github.io/vis-network/docs/network/
const networkOptions = {
  autoResize: true,
  height: '100%',
  width: '100%',
  locale: 'en',
  clickToUse: false
}

// https://visjs.github.io/vis-network/docs/network/configure.html
//networkOptions['configure'] = {
//}

// https://visjs.github.io/vis-network/docs/network/nodes.html


networkOptions['nodes'] = {
  scaling: {
    min: 10,
    max: 40
  },
  font: {
      size: 14,
      face: 'arial'
  },
  shape: 'icon',
  icon: {
    face: "'FontAwesome'",
    code: '\uf111',
    size: 40,
    color: '#F0A30A'
  },
  size: 30
}

// https://visjs.github.io/vis-network/docs/network/edges.html
networkOptions['edges'] = {
  width: 0.15,
  color: '#a0a0a0',
  font: {
    color: '#808080',
    size: 8,
    face: 'arial',
    background: 'none',
    strokeWidth: 3, // px
    strokeColor: '#ffffff',
    align:'horizontal'
  },
  smooth: {
      type: 'continuous'
  },
  selectionWidth: 2,

  arrows: 'to'
}

// https://visjs.github.io/vis-network/docs/network/layout.html
networkOptions['layout'] = {
  randomSeed: 3
}

// https://visjs.github.io/vis-network/docs/network/manipulation.html
networkOptions['manipulation'] = {
  enabled: false
}

// https://visjs.github.io/vis-network/docs/network/physics.html
networkOptions['physics'] = {
  timestep: 0.5,
  stabilization: {
      enabled: true,
      fit: true
  },
  minVelocity: 1.1,
  barnesHut: {
      gravitationalConstant: -10000,
      springConstant: 0.02,
      centralGravity: 1.5,
      //avoidOverlap: 0.6,
      damping: 0.2
  }
}

// https://visjs.github.io/vis-network/docs/network/interaction.html
networkOptions['interaction'] = {
  hover: true,
  tooltipDelay: 200,
  multiselect: true
}

// https://visjs.github.io/vis-network/docs/network/groups.html
networkOptions['groups'] = {
  machine: {
    icon: {
      code: '\uf109',
      color: '#ADF1B1'
    }
  },
  account: {
    icon: {
      code: '\uf007',
      color: '#49C4A3'
    }
  },
  process: {
    icon: {
      code: '\uf15b',
      color: '#F0A30A'
    }
  },
  file: {
    icon: {
      code: '\uf109',
      color: '#ADF1B1'
    }
  },
  registry: {
    icon: {
      code: '\uf1c0',
      color: '#7E82C4'
    }
  },
  environment: {
    icon: {
      code: '\uf4d8',
      color: '#ADF1B1'
    }
  },
  faas: {
    icon: {
      code: '\uf111',
      color: '#49C4A3'
    }
  },
  firewall: {
    icon: {
      code: '\uf256',
      color: '#F0A30A'
    }
  },
  identitygroup: {
    icon: {
      code: '\ue533',
      color: '#ADF1B1'
    }
  },
  identitypolicy: {
    icon: {
      code: '\uf111',
      color: '#7E82C4'
    }
  },
  identityprovider: {
    icon: {
      code: '\uf7d3',
      color: '#ADF1B1'
    }
  },
  image: {
    icon: {
      code: '\uf03e',
      color: '#49C4A3'
    }
  },
  kubernetes: {
    icon: {
      code: '\uf111',
      color: '#F0A30A'
    }
  },
  log: {
    icon: {
      code: '\uf15c',
      color: '#ADF1B1'
    }
  },
  securitycontrol: {
    icon: {
      code: '\uf3ed',
      color: '#7E82C4'
    }
  },
  storage: {
    icon: {
      code: '\uf1c0',
      color: '#ADF1B1'
    }
  },

}

